// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductStyles } from "@synd/Overrides/Components/ProductCarouselProduct";
import { css } from "styled-components";

productCarouselProductStyles.overlayBadge = {
    css: css`
        ${({ view }: any) =>
            view !== "miniCard" &&
            css`
                position: absolute;
                top: 4px;
                left: 4px;
            `}
    `,
};

productCarouselProductStyles.badgeAreaWrapper = {
    css: css`
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

productCarouselProductStyles.productAddToListLinkStyles = {};

productCarouselProductStyles.customBadgesStyles = {
    wrapper: {
        css: css`
            position: absolute;
            top: 4px;
            left: 4px;
        `,
    },
};

productCarouselProductStyles.miniCardCustomBadgesStyles = {
    wrapper: {
        css: css`
            margin-top: 8px;
        `,
    },
};
